import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { label: "Work", href: "#work" },
  { label: "Services", href: "#services" },
  { label: "Demos", href: "#demos" },
  { label: "Process", href: "#process" },
  { label: "About", href: "#about" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled ? "bg-cream/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="container-edit flex items-center justify-between py-5">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2"
          aria-label="Melavate Studios"
        >
          <span className="font-display text-2xl text-plum-deepest leading-none">
            MEL<span className="text-gold-deep">avate</span>
          </span>
          <span className="hidden sm:inline-block text-[0.65rem] tracking-[0.28em] uppercase text-muted-plum font-semibold mt-1">
            Studios
          </span>
        </a>

        <div className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className="text-sm font-semibold text-plum-deepest hover:text-gold-deep transition-colors tracking-wide"
            >
              {link.label}
            </a>
          ))}
          <a href="#contact" data-testid="nav-cta" className="btn-gold">
            Start a Project
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-plum-deepest"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden bg-cream border-t border-plum/10">
          <div className="container-edit flex flex-col py-6 gap-4">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="text-base font-semibold text-plum-deepest"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="btn-gold mt-2 self-start"
            >
              Start a Project
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
